import { EyeTestTimeSlot } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import { FC } from "react";

interface TimeSlotProps {
  slot: EyeTestTimeSlot;
  selectedTimeSlot?: EyeTestTimeSlot;
  onChange: (slot: EyeTestTimeSlot) => void;
}

const TimeSlot: FC<TimeSlotProps> = ({ slot, onChange, selectedTimeSlot }) => {
  const isSelected = selectedTimeSlot?.start === slot.start;

  return (
    <div className="col-span-4 flex h-full items-center justify-center">
      <div className="relative">
        <input
          className="sr-only"
          type="radio"
          name="timeSlot"
          id={slot.start}
          checked={isSelected}
          onChange={() => onChange(slot)}
          disabled={!slot.isAvailable}
        />
        <label
          htmlFor={slot.start}
          className={cn(
            "relative block h-full w-full cursor-pointer overflow-hidden border px-2 py-2 text-center text-[0.875rem] font-normal transition",
            isSelected
              ? "border-none bg-black text-white"
              : "border-gray-300 bg-white text-gray-800 hover:bg-gray-100",
            !slot.isAvailable && "text-[#EEEEEE]",
          )}
        >
          {slot.start}-{slot.end}
          {!slot.isAvailable && <span className="diagonal-line"></span>}
        </label>
      </div>
    </div>
  );
};

export default TimeSlot;
